/**
 * Kirish sahifasining foni: ikki qatlam.
 *
 *  1. Temir yo'l panjarasi — ikkita rels va ular ostidagi shpallar. Naqsh
 *     `currentColor` bilan chiziladi, shuning uchun yorug' temada quyuq,
 *     qorong'ida esa och bo'ladi; `opacity-[0.04]` da u matnga xalaqit
 *     bermaydi, lekin ekran bo'sh qog'ozdek ko'rinmaydi.
 *  2. Yuqori chapdan tushadigan aksent yorug'ligi — `--color-accent` ning
 *     8% aralashmasi. Rang tokendan olinadi, bu yerda HEX yo'q.
 *
 * Endi u ikki joyda ishlatiladi: sahifaning o'z foni sifatida va WebGL
 * yo'q kompyuterda 3D sahnaning **zaxirasi** sifatida. Ikkinchi holatda fon
 * quyuq, shuning uchun naqsh rangi va tiniqligi tashqaridan beriladi.
 */
export interface LoginBackdropProps {
  /** Naqsh sinflari — quyuq panelda ochroq va sezilarliroq bo'lishi kerak. */
  patternClassName?: string;
}

export const LoginBackdrop = ({
  patternClassName = 'text-text opacity-[0.04]',
}: LoginBackdropProps = {}) => (
  <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
    <svg className={`absolute inset-0 h-full w-full ${patternClassName}`}>
      <defs>
        <pattern id="eombor-rail-grid" width="144" height="144" patternUnits="userSpaceOnUse">
          {/* ikkita rels */}
          <path d="M0 52h144M0 92h144" fill="none" stroke="currentColor" strokeWidth="1.5" />
          {/* shpallar — relsdan bir oz chiqib turadi, xuddi haqiqiy yo'ldagidek */}
          <path
            d="M9 46v52M27 46v52M45 46v52M63 46v52M81 46v52M99 46v52M117 46v52M135 46v52"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#eombor-rail-grid)" />
    </svg>

    <div
      className="absolute inset-0"
      style={{
        background:
          'radial-gradient(120% 100% at 8% -10%, color-mix(in oklab, var(--color-accent) 8%, transparent) 0%, transparent 62%)',
      }}
    />
  </div>
);
